<template>
  <div class="component-detail-record">
    <div class="search-hd">
      <el-form
        :inline="true"
        @submit.native.prevent
      >
        <!-- 导出 -->
        <el-form-item style="float: right; margin-right: 0">
          <el-button
            class="table-set"
            style="vertical-align: top"
            @click="dialogVisible = true"
          >
            <i class="icon icon-daochu"></i>
          </el-button>
        </el-form-item>
        <!-- 事件代码 -->
        <el-form-item style="float: right">
          <search-input
            v-model="formSearch.eventCode"
            :placeholder="$t('components_component_detail_record.shi_jian_dai_ma')"
            @fetch="onPageChange({ page: 1 })"
          ></search-input>
        </el-form-item>
        <el-form-item style="float: right; margin-right: 8px">
          <switch-button :link="$refs.container"></switch-button>
        </el-form-item>
        <el-form-item style="float: right; margin-right: 8px">
          <custom-select
            v-model="formSearch.eventQueryType"
            code="event_query_type"
            :placeholder="$t('Common.com_please_select')"
            width="100px"
            :clearable="false"
            @change="onPageChange({ page: 1 })"
          ></custom-select>
        </el-form-item>
      </el-form>
    </div>
    <switch-container
      ref="container"
      @search="onPageChange({ page: 1 })"
      @clear="clearFilter('keyword')"
    >
      <el-form
        :inline="true"
        label-position="top"
      >
        <el-form-item :label="$t('components_component_detail_record.ji_lu_shi_jian')">
          <custom-date-picker
            v-model="formSearch.timer"
            type="datetimerange"
            align="right"
            value-format="YYYY-MM-DD HH:mm:ss"
            init-Value="dateInit"
            :picker-options="eventIntervalDays"
            :clearable="false"
            style="width: 100%"
          ></custom-date-picker>
        </el-form-item>
        <el-form-item :label="$t('components_component_detail_record.shang_chuan_shi_jian')">
          <custom-date-picker
            v-model="formSearch.uploadTimer"
            type="datetimerange"
            align="right"
            init-Value="dateInit"
            value-format="YYYY-MM-DD HH:mm:ss"
            :picker-options="pickerOptionDisAfter"
            style="width: 100%"
          ></custom-date-picker>
        </el-form-item>
      </el-form>
    </switch-container>
    <div class="table-bd">
      <custom-table
        :data="tableList"
        :index="true"
        :column="tableColumn"
        height="100%"
        @filter="filterChange"
        @sort="sortChange"
      ></custom-table>
    </div>
    <div class="table-page">
      <el-pagination
        border
        v-if="totalRows"
        @size-change="getData('init')"
        @current-change="getData"
        :current-page.sync="formSearch.pageNum"
        :page-size.sync="formSearch.pageSize"
        :page-sizes="pageSizeList"
        layout="sizes, prev, pager, next, slot, jumper"
        :total="totalRows"
      ></el-pagination>
    </div>
    <device-date-event-datePicker
      v-if="dialogVisible"
      @close="dialogVisible = false"
      @success="exportTable"
      v-model="exportTimer"
    ></device-date-event-datePicker>
  </div>
</template>

<script>
import customTable from '@/components/customTable.vue';
import apis from '@/utils/apis.js';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins.js';

import languageInjectMixins from '@/mixins/language_inject_mixins';
import deviceDateEventDatePicker from '@/components/device_detail_date_datePicker.vue';
import moment from 'moment';

export default {
  mixins: [languageInjectMixins, resetFormSearchMixins],
  components: {
    customTable,
    deviceDateEventDatePicker
  },
  props: {
    model: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      tableCode: 'device_event_record',
      formSearch: {
        pageSize: 20,
        pageNum: 1,
        eventCode: '',
        dateInit: [],
        startDate: '',
        endDate: '',
        timer: [this.$momentWorld(moment().subtract(3, 'months').format('YYYY-MM-DD 00:00:00')), this.$momentWorld(moment().format('YYYY-MM-DD 23:59:59'))],

        uploadStartDate: '',
        uploadEndDate: '',
        uploadTimer: [],
        eventQueryType: '0',
      },

      tableList: [],
      tableColumn: [],
      totalRows: null,

      exportTimer: '',
      dialogVisible: false
    };
  },
  mounted() {
    this.dateInit = [
      this.$moment()
        .subtract('days', 6)
        .format('YYYY-MM-DD 00:00:00'),
      this.$moment().format('YYYY-MM-DD 23:59:59')
    ];
    // this.mergeCompLanguage();
    this.getTableColumn();
    this.getData();
  },
  methods: {
    getData(data) {
      if (data === 'init') {
        this.formSearch.pageNum = 1;
      }
      // this.formSearch.endDate = moment(this.formSearch.startDate).format(
      //   'YYYY-MM-DD 23:59:59'
      // );
      this.$getJSON(apis.DeviceResumeComponentEventPage, this.getReqData()).then((res) => {
        this.tableList = res.data.list || [];
        this.totalRows = res.data.total;
      });
    },

    getReqData() {
      return {
        ...this.formSearch,
        startDate: this.formSearch.timer && this.formSearch.timer[0] ? this.formSearch.timer[0] : '',
        endDate: this.formSearch.timer && this.formSearch.timer[1] ? this.formSearch.timer[1] : '',
        uploadStartDate: this.formSearch.uploadTimer && this.formSearch.uploadTimer[0] ? this.formSearch.uploadTimer[0] : '',
        uploadEndDate: this.formSearch.uploadTimer && this.formSearch.uploadTimer[1] ? this.formSearch.uploadTimer[1] : '',
        bodyNum: this.model.bodyNum,
        componentCode: this.model.componentCode
      };
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getData();
    },
    // 数据导出
    exportTable: function () {
      const startDate = this.exportTimer && this.exportTimer[0] ? this.exportTimer[0] : undefined;
      const endDate = this.exportTimer && this.exportTimer[1] ? this.exportTimer[1] : undefined;
      this.$exportFlie(apis.DeviceResumeComponentEventExport, {
        pageSize: 20,
        pageNum: 1,
        bodyNum: this.model.bodyNum,
        componentCode: this.model.componentCode,
        startDate,
        endDate
      }).then(() => { });
    }
  }
};
</script>

<style lang="scss">
.component-detail-record {
  display: flex;
  flex-direction: column;
  height: 100%;
  .el-form-item {
    margin-bottom: 0 !important;
    &:last-child {
      margin-right: 0;
    }
  }
  .slot-container .el-form-item {
    width: 50% !important;
    margin: 0 !important;
    margin-bottom: 0px !important;
    padding: 0 8px;
  }
}
</style>
